(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10);
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '{{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? '.' : thousands;
      decimal = decimal == null ? ',' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsStr = parts[1] ? decimal + parts[1] : '';
      return dollars + centsStr;
    }

    const match = formatString.match(placeholderRegex);
    if (!match) return cents;
    let value = '';
    switch (match[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function getCartProductIds() {
    return fetch('/cart.js')
      .then(r => r.json())
      .then(cart => (cart.items || []).map(i => i.product_id));
  }

  function initUpsells() {
    const container = document.getElementById('CartDrawer-Upsells');
    if (!container) return;

    const productId = container.dataset.productId;
    if (!productId) return;

    const grid = document.getElementById('CartDrawer-UpsellsGrid');
    if (!grid) return;

    if (grid.dataset.loaded === productId) return;

    const moneyFormat = container.dataset.moneyFormat;

    Promise.all([
      fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related').then(r => r.ok ? r.json() : Promise.reject()),
      getCartProductIds()
    ])
      .then(([data, cartProductIds]) => {
        const products = (data.products || [])
          .filter(p => p.available && !cartProductIds.includes(p.id))
          .slice(0, 3);

        if (products.length === 0) {
          container.style.display = 'none';
          return;
        }

        grid.dataset.loaded = productId;
        grid.innerHTML = products.map(p => {
          const variant = p.variants[0];
          const price = formatMoney(variant.price, moneyFormat);
          let imgSrc = '';
          if (p.featured_image) {
            const src = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.src || '');
            if (src) imgSrc = src + (src.includes('?') ? '&' : '?') + 'width=120';
          }
          const safeTitle = p.title.replace(/"/g, '&quot;').replace(/</g, '&lt;');
          return [
            '<div class="cart-upsell-card" data-variant-id="' + variant.id + '">',
            imgSrc
              ? '<a href="' + p.url + '" class="cart-upsell-card__img-wrap" tabindex="-1"><img src="' + imgSrc + '" alt="' + safeTitle + '" width="55" height="55" loading="lazy"></a>'
              : '',
            '<div class="cart-upsell-card__info">',
            '<a href="' + p.url + '" class="cart-upsell-card__title">' + safeTitle + '</a>',
            '<p class="cart-upsell-card__price">' + price + '</p>',
            '</div>',
            '<button class="cart-upsell-card__btn" type="button" aria-label="Añadir ' + safeTitle + ' a la cesta">Añadir</button>',
            '</div>'
          ].join('');
        }).join('');

        grid.querySelectorAll('.cart-upsell-card__btn').forEach(function (btn) {
          btn.addEventListener('click', handleAdd);
        });
      })
      .catch(function () {
        if (container) container.style.display = 'none';
      });
  }

  function handleAdd(e) {
    const btn = e.currentTarget;
    const card = btn.closest('.cart-upsell-card');
    const variantId = parseInt(card.dataset.variantId, 10);

    btn.disabled = true;
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function () {
        btn.textContent = '✓';

        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cartData) {
            document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
              const spans = el.querySelectorAll('span');
              spans.forEach(function (s) {
                if (!s.classList.contains('visually-hidden')) s.textContent = cartData.item_count;
              });
            });
          });

        setTimeout(function () {
          card.style.opacity = '0';
          setTimeout(function () {
            card.remove();
            const grid = document.getElementById('CartDrawer-UpsellsGrid');
            if (grid && grid.children.length === 0) {
              const container = document.getElementById('CartDrawer-Upsells');
              if (container) container.style.display = 'none';
            }
          }, 300);
        }, 900);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Añadir';
      });
  }

  function onDrawerOpen() {
    const grid = document.getElementById('CartDrawer-UpsellsGrid');
    if (grid) delete grid.dataset.loaded;
    initUpsells();
  }

  document.addEventListener('DOMContentLoaded', function () {
    const drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return;

    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          if (drawerEl.classList.contains('active')) onDrawerOpen();
        }
      });
    }).observe(drawerEl, { attributes: true });

    if (drawerEl.classList.contains('active')) onDrawerOpen();
  });
})();
